{
  "version": 1,
  "asset_id": "fadd323b-9edc-44fe-816a-43756e245cee",
  "project_id": "323b9e15-9042-4162-b531-66ca33513bd6",
  "url": "/__l5e/assets-v1/fadd323b-9edc-44fe-816a-43756e245cee/mrdrive-events.png",
  "r2_key": "a/v1/323b9e15-9042-4162-b531-66ca33513bd6/fadd323b-9edc-44fe-816a-43756e245cee/mrdrive-events.png",
  "original_filename": "mrdrive-events.png",
  "size": 1875936,
  "content_type": "image/png",
  "created_at": "2026-07-17T00:25:18Z"
}
